import { apiUrl } from '../../../settings'

export const addSubscriptionActivityUrl = () => {
  return apiUrl + '/addGeneralSubscriptionActivity'
}
export const updateInvoiceStatusUrl = () => {
  return apiUrl + '/api/updateInvoiceStatus'
}
export const allGeneralSubscriptionUrl = () => {
  return apiUrl + '/allGeneralSubscription'
}
export const getSingleGeneralSubscriptionByIdUrl = () => {
  return apiUrl + '/api/getSingleGeneralSubscriptionById'
}
export const addCourierUrl = () => {
  return apiUrl + '/addCourierDetails'
}
